import { Hospital, EditFormData, SearchPayload, CountsPayload, FilterType } from '../types/hospital.types';

export const buildSearchPayload = (
  searchTerm: string,
  currentPage: number,
  filter: FilterType,
  itemsPerPage: number,
  isDeleted: boolean = false,
  insuranceFilter: string = ''
): SearchPayload => ({
  searchInput: searchTerm || undefined,
  limit: itemsPerPage,
  page: currentPage,
  isDeleted,
  ...(filter === 'esic' && { isEsic: true }),
  ...(filter === 'emergency' && { handleEmergency: true }),
  ...(insuranceFilter && { insuranceList: [{ nameOfInsurer: insuranceFilter }] })
});

export const buildCountsPayload = (): CountsPayload => ({
  total: true,
  isEsic: true,
  handleEmergency: true,
  isDeleted: false
});

export const initializeEditForm = (hospital: Hospital): EditFormData => ({
  name: hospital.name,
  address: hospital.address,
  coordinates: hospital.location.coordinates.join(', '),
  'formattedData.name': hospital.formattedData?.name || '',
  'formattedData.address': hospital.formattedData?.address || '',
  'formattedData.city': hospital.formattedData?.city || '',
  'formattedData.district': hospital.formattedData?.district || '',
  'formattedData.state': hospital.formattedData?.state || '',
  'formattedData.pincode': hospital.formattedData?.pincode || '',
  isEsic: hospital.isEsic,
  handleEmergency: hospital.handleEmergency,
  speciality: hospital.speciality.join(', '),
  insuranceList: hospital.insuranceList
});

export const processFormData = (formData: EditFormData): any => {
  const processedData: any = {};
  
  Object.entries(formData).forEach(([field, value]) => {
    if (field === 'coordinates' && typeof value === 'string') {
      const coords = value.split(',').map(c => parseFloat(c.trim()));
      if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
        processedData.location = { 
          type: 'Point', 
          coordinates: [Number(coords[0]), Number(coords[1])] 
        };
      }
    } else if (field === 'speciality' && typeof value === 'string') {
      processedData[field] = value.split(',').map(item => item.trim()).filter(Boolean);
    } else if (field === 'insuranceList') {
      processedData[field] = value;
    } else if (field.startsWith('formattedData.')) {
      const subField = field.replace('formattedData.', '');
      if (!processedData.formattedData) processedData.formattedData = {};
      processedData.formattedData[subField] = value;
    } else {
      processedData[field] = value;
    }
  });
  
  return processedData;
};